import { React, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  DownArrowDraw,
  ContentMiddle
  // PaginationStyle
} from "../../styledElements";
import {
  DatePickerY,
  DisabledButtonStyle,
  GlobalSet,
} from "../../pageStyled";
import { DatePicker } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Tooltip,
} from "antd";
import { HaberForm } from "../../styledElements";
import { useWindowDimensions } from "../../../hooks/useWindowDimensions";
import {
  getProducts,
} from "../../../Services/productServices";
import {
  saveConflictingOrders,
} from "../../../Services/orderServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import moment from "moment";
import styled from "styled-components";
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { getUnitData } from "../../../Services/measurementService";
import {
  currency_List,
} from "../../../Utils/Constant/MeasurementUnitList";
import AddNewCustomerDrawer from "./AddNewCustomerDrawer";
import AddProductDrawer from "./AddProductDrawer";
import AddQualityDrawer from "./AddQualityDrawer";
import { getCustomersForConfiguration } from "../../../Services/customerServices";
import { getMachineGradeSelectForConfig } from "../../../Services/settingsServices";
import { toHandlePOName } from "../../../Utils/helper/helper";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import LottieAnimation from "../../../Lottie";
import Loader from "../../../Components/IconsFiles/loader"
import axios from "axios";

const TooltipSelector = styled.div`
  .edit-tooltip {
    max-width: none !important;
    width: fit-content !important;
    overflow: visible !important;
    z-index: 9999 !important;
  }
  .edit-tooltip .ant-tooltip-inner {
    white-space: nowrap !important;
    max-width: none !important;
    width: fit-content !important;
    background: rgba(32, 31, 30, 0.85) !important;
    color: white !important;
    border-radius: 8px !important;
    padding: 7px 12px !important;
    font-family: var(--sf-pro-display-m);
    font-size: 12px;
    line-height: 16px;
  }
  .edit-tooltip .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
    top: 3px;
    right: 13px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid black;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #ea655b !important;
    border-color: #dfe1e6 !important;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #ea655b !important;
  }
  .ant-checkbox-checked::after {
    border-color: #ea655b !important;
  }
`;

const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const ReviewConflictingOrders = (props) => {
  const location = useLocation();
  const history = useNavigate();
  const source = axios.CancelToken.source();

  const { height, width } = useWindowDimensions();
  const { Option } = Select;
  const [form] = Form.useForm();
  const [filteredOrders, setFilteredOrders] = useState(
    location?.state?.orderData
  );
  const [loading, setLoading] = useState(false);
  const [ordersToShow, setOrdersToShow] = useState();
  const [rerendering, setRerendering] = useState(false);
  const [products, setProducts] = useState([]);
  const [customerDrawerVisible, setCustomerDrawerVisible] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [settingsData, setSettingsData] = useState(
    JSON.parse(localStorage.getItem("setting-data"))
  );
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [customerRecords, setCustomerRecords] = useState([]);
  const [gradeData, setGradeData] = useState([]);
  const [orderData, setOrderData] = useState();
  const [productDrawerVisible, setProductDrawerVisible] = useState(false);
  const [qualityDrawerVisible, setQualityDrawerVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const [saveModalVisible, setSaveModalVisible] = useState(false);
  const [saveApiDataVisible, setSaveApiDatalVisible] = useState(false);
  const [isVisibleWarning, setIsVisibleWarning] = useState(false);
  const [disabledButton,setDisabledButton] = useState(false);
  const rowCount = useRef(false);

  useEffect(()=>{
 return () => {
    source.cancel("Page is redirected");
  };
  },[])

  useEffect(() => {
    (async () => {
      document.body.style.overflow = "hidden";

      const resp = await getMachineGradeSelectForConfig();
      if (!resp.error) {
        setGradeData(resp.data.data.settings?.grades);
      }

      getCustomersForConfiguration()
        .then((res) => {
          setCustomerRecords(res);
        })
        .catch((error) => {
          setCustomerRecords([]);
          console.log("Error in fetching customer list:", error);
        });

      getProducts({ status: "active" })
        .then((response) => {
          setProducts(response);
        })
        .catch((error) => {
          setProducts([]);
          console.log("Error in fetching products list:", error);
        });

      setIsVisibleWarning(filteredOrders?.some(ele => (ele.errors || {}).hasOwnProperty('active_jobcard_conflict')));

      // let orderstoshow = [];
      // filteredOrders?.map((item, index) => {
      //   if (index < 25) {
      //     orderstoshow.push(item);
      //   }
      // });
      setOrdersToShow(filteredOrders);
    })();
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    if (rerendering) {
      form.resetFields();
      setRerendering(false);
    }
  }, [rerendering]);

  const setRowCount = () => {
    rowCount.current = true;
  };

  const onCloseCustomerDrawer = () => {
    setCustomerDrawerVisible(false);
  };

  const closeProductDrawer = () => {
    setProductDrawerVisible(false);
  };

  const closeQualityDrawer = () => {
    setQualityDrawerVisible(false);
  };

  const onCustomerSave = async (response) => {
    console.log(response);
    const res = await getCustomersForConfiguration();
    setCustomerRecords(res);

    let updatedFilterArray = filteredOrders?.map((item) => {
      if (item?.orders?.customer_name === orderData?.orders?.customer_name) {
        const { customer, ...restErrors } = item.errors || {};
        return {
          ...item,
          po:{
            ...item?.po,
            customer: response?.data?.code,
            consignee: response?.data?.code
          },
          orders: {
            ...item.orders,
            customer: response?.data?.code,
            customer_name: response?.data?.name,
          },
          errors: restErrors,
          error_count: Math.max(0, item.error_count - (customer ? 1 : 0)), // reduce if customer error existed
        };
      }
      return item;
    });

    setOrdersToShow(updatedFilterArray);
    setFilteredOrders(updatedFilterArray);
    setCustomerDrawerVisible(false);
    setRerendering(true);
  };

  const setNewProductData = async (response) => {
    console.log(response);
    const productData = await getProducts({ status: "active" });
    setProducts(productData);

    let updatedFilterArray = filteredOrders?.map((item) => {
      if (
        item?.orders?.product_data?.erp_product_specs ===
        orderData?.orders?.product_data?.erp_product_specs
      ) {
        const { product, ...restErrors } = item.errors || {};
        return {
          ...item,
          orders: {
            ...item.orders,
            product: response?.code,
            product_data: {
              ...item?.orders?.product_data,
              name: response?.name,
            },
          },
          errors: restErrors,
          error_count: Math.max(0, item.error_count - (product ? 1 : 0)), // reduce if product error existed
        };
      }
      return item;
    });

    setOrdersToShow(updatedFilterArray);
    setFilteredOrders(updatedFilterArray);
    setProductDrawerVisible(false);
    setRerendering(true);
  };

  const onSaveQuality = async (response) => {
    console.log(response);
    const resp = await getMachineGradeSelectForConfig();
    if (!resp.error) {
      setGradeData(resp.data.data.settings?.grades);
    }

    let updatedFilterArray = filteredOrders?.map((item) => {
      if (
        item?.orders?.product_data?.quality ===
        orderData?.orders?.product_data?.quality
      ) {
        const { quality, ...restErrors } = item.errors || {};
        return {
          ...item,
          orders: {
            ...item.orders,
            product_data: {
              ...item?.orders?.product_data,
              quality: response,
            },
          },
          errors: restErrors,
          error_count: Math.max(0, item.error_count - (quality ? 1 : 0)), // reduce if product error existed
        };
      }
      return item;
    });

    setOrdersToShow(updatedFilterArray);
    setFilteredOrders(updatedFilterArray);
    setQualityDrawerVisible(false);
    setRerendering(true);
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 3000);
  };

  const handleScroll = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const addNewCustomer = (record) => {
    setOrderData(record);
    setCustomerDrawerVisible(true);
  };

  const addNewProduct = (record) => {
    setOrderData(record);
    setProductDrawerVisible(true);
  };

  const addNewQuality = (record) => {
    setOrderData(record);
    setQualityDrawerVisible(true);
  };

  // const handleCustomer = (record, event) => {
  //   let updatedFilterArray = filteredOrders?.map((item) => {
  //     if (item?.orders?.erp_order_id === record?.orders?.erp_order_id) {
  //       const { customer, ...restErrors } = item.errors || {};
  //       return {
  //         ...item,
  //         po:{
  //           ...item?.po,
  //           customer: event,
  //           consignee: event
  //         },
  //         orders: {
  //           ...item.orders,
  //           product_data: {
  //             ...item?.orders?.product_data,
  //             name: products?.filter((ele) => ele.code == event)[0]?.name,
  //           },
  //           customer: event,
  //           customer_name: customerRecords?.filter(
  //             (ele) => ele.code == event
  //           )[0]?.name,
  //           isCustDropdownClicked: true,
  //         },
  //         errors: restErrors,
  //         error_count: Math.max(0, item.error_count - (customer ? 1 : 0)), // reduce if customer error existed
  //       };
  //     }
  //     return item;
  //   });

  //   setOrdersToShow(updatedFilterArray);
  //   setFilteredOrders(updatedFilterArray);
  //   setRerendering(true);
  // };

  const onOrderQtyChange = (record, event) => {
    let updatedFilterArray = filteredOrders?.map((item) => {
      if (item?.orders?.erp_order_id === record?.orders?.erp_order_id) {
        const { weight, ...restErrors } = item.errors || {};
        return {
          ...item,
          orders: {
            ...item.orders,
            weight: event?.target?.value,
            isOrderQtyChanged: true,
          },
          errors: restErrors,
          error_count: Math.max(0, item.error_count - (weight ? 1 : 0)),
        };
      }
      return item;
    });

    setOrdersToShow(updatedFilterArray);
    setFilteredOrders(updatedFilterArray);
    setRerendering(true);
  };

  const onBalanceQtyChange = (record, event) => {
    let updatedFilterArray = filteredOrders?.map((item) => {
      if (item?.orders?.erp_order_id === record?.orders?.erp_order_id) {
        const { balance_weight, ...restErrors } = item.errors || {};
        return {
          ...item,
          orders: {
            ...item.orders,
            balance_weight: event?.target?.value,
            isBalanceQtyChanged: true,
          },
          errors: restErrors,
          error_count: Math.max(0, item.error_count - (balance_weight ? 1 : 0)),
        };
      }
      return item;
    });

    setOrdersToShow(updatedFilterArray);
    setFilteredOrders(updatedFilterArray);
    setRerendering(true);
  };

  const onSizeChange = (record, event) => {
    let updatedFilterArray = filteredOrders?.map((item) => {
      if (item?.orders?.erp_order_id === record?.orders?.erp_order_id) {
        const { width, ...restErrors } = item.errors || {};
        return {
          ...item,
          orders: {
            ...item.orders,
            width: event?.target?.value,
            isSizeChanged: true,
          },
          errors: restErrors,
          error_count: Math.max(0, item.error_count - (width ? 1 : 0)),
        };
      }
      return item;
    });

    setOrdersToShow(updatedFilterArray);
    setFilteredOrders(updatedFilterArray);
    setRerendering(true);
  };

  const handleQuality = (record, event) => {
    let updatedFilterArray = filteredOrders?.map((item) => {
      if (item?.orders?.erp_order_id === record?.orders?.erp_order_id) {
        const { quality, ...restErrors } = item.errors || {};
        return {
          ...item,
          orders: {
            ...item.orders,
            product_data: {
              ...item?.orders?.product_data,
              quality: event,
            },
            isQualityChanged: true,
          },
          errors: restErrors,
          error_count: Math.max(0, item.error_count - (quality ? 1 : 0)),
        };
      }
      return item;
    });

    setOrdersToShow(updatedFilterArray);
    setFilteredOrders(updatedFilterArray);
    setRerendering(true);
  };

  // const handleProduct = (record, event) => {
  //   let updatedFilterArray = filteredOrders?.map((item) => {
  //     if (item?.orders?.erp_order_id === record?.orders?.erp_order_id) {
  //       const { product, ...restErrors } = item.errors || {};
  //       return {
  //         ...item,
  //         orders: {
  //           ...item.orders,
  //           product: event,
  //           product_data: {
  //             ...item?.orders?.product_data,
  //             name: products?.filter((ele) => ele.code == event)[0]?.name,
  //           },
  //           isProductChanged: true,
  //         },
  //         errors: restErrors,
  //         error_count: Math.max(0, item.error_count - (product ? 1 : 0)),
  //       };
  //     }
  //     return item;
  //   });

  //   setOrdersToShow(updatedFilterArray);
  //   setFilteredOrders(updatedFilterArray);
  //   setRerendering(true);
  // };

  const onDateChange = (record, newDate) => {
    if (!newDate || !moment(newDate).isValid()) return;
    const dateStr = moment(newDate).format("YYYY-MM-DD 00:00:00");

    let updatedFilterArray = filteredOrders?.map((item) => {
      if (item?.orders?.erp_order_id === record?.orders?.erp_order_id) {
        const { date, ...restErrors } = item.errors || {};
        return {
          ...item,
          po: {
            ...item.po,
            date: dateStr,
          },
          orders: {
            ...item.orders,
            isDateChanged: true,
          },
          errors: restErrors,
          error_count: Math.max(0, item.error_count - (date ? 1 : 0)),
        };
      }
      return item;
    });

    setOrdersToShow(updatedFilterArray);
    setFilteredOrders(updatedFilterArray);
    setRerendering(true);
  };

  const saveOrders = () => {
    setSaveModalVisible(true);

  };

  const cancelSaveModal = () => {
    setSaveModalVisible(false);
  };

  const confirmSaveModal = async () => {
  setDisabledButton(true);

  const cleanedOrderData = filteredOrders?.reduce((acc, entry) => {
    if (
      entry.error_count === 0 &&
      Object.keys(entry.errors || {}).length === 0
    ) {
      const {
        isCustDropdownClicked,
        isOrderQtyChanged,
        isBalanceQtyChanged,
        isSizeChanged,
        isQualityChanged,
        isProductChanged,
        isDateChanged,
        ...restOrders
      } = entry.orders;

      acc.push({
        ...entry,
        orders: restOrders,
      });
    }
    return acc;
  }, []);

  console.log(cleanedOrderData);

  const BATCH_SIZE = 100;
  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const batches = chunkArray(cleanedOrderData, BATCH_SIZE);

  const uploadAllBatches = async () => {
    const promises = batches.map((batch, batchIndex) =>
      saveConflictingOrders(batch,source)
        .then((response) => ({
          success: true,
          response,
          batchIndex,
        }))
        .catch((error) => ({
          success: false,
          error,
          batchIndex,
        }))
    );

    const allResults = await Promise.all(promises);
    console.log("All batches completed:", allResults);
    return allResults;
  };

  setSaveModalVisible(false);

  const response = await uploadAllBatches();
const check=Array.isArray(response) && response.some(item => item.success === false)
  if (check) {
    setSaveApiDatalVisible(true);
  } else {
    setActionToaster({
      error: false,
      msg: "All orders have been successfully saved",
    });
    showToaster();
    setTimeout(
      () => history("../order-records", { state: { refetch: true } }),
      5000
    );
  }

};


  const onFinish = async () => {
    //   console.log(filteredOrders);
    //   setSaveModalVisible(false);
  };

  const onCancel = () => {
    setVisible(true);
  };

  const modalCancel = () => {
    setVisible(false);
  };

  const modalConfirm = () => {
    history("../order-records", {
      state: {
        action: "cancel",
        msg: `${filteredOrders?.length} orders have been discarded`,
        refetch:true
      },
    });
    setVisible(false);
  };
  const modalApiDataConfirm = () => {
    history("../order-records", {
      state:{
        refetch:true
    }
  });
    setSaveApiDatalVisible(false);
  };

  const RowData = ({ index, style }) =>
    index !== undefined && (
      //old   <div style={style} className="removeStar">
      <div
        style={{
          ...style,
          padding: "4px 0",
          boxSizing: "border-box",
          // borderBottom: "1px solid #f0f0f0",
          //   display: "flex",
          alignItems: "center",
        }}
        className="removeStar"
      >
        <Row
          //old   gutter={[10, 10]}
          gutter={[10, 10]}
          className="groupForm"
          //old   style={{ width: "160%", marginBottom: "10px", paddingBottom: "10px" }}
          style={{ width: "230%", marginTop: "10px" }}
          align="top"
        >
          {/* new changes */}
          {/* Icon */}
          <Col
            flex="30px"
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "40px",
            }}
          >
            <div>
              {ordersToShow[index].error_count ||
              Object.keys(ordersToShow[index].errors).filter(
                (key) => key in ordersToShow[index].orders
              )?.length > 0 ? (
                <Iconmoon icon="wrong" size={16} color="#EA655B" />
              ) : (
                <Iconmoon icon="correct" size={16} color="#3FBD61" />
              )}
            </div>
          </Col>

          {isVisibleWarning && <Col
            flex="30px"
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "40px",
            }}
          >
            {ordersToShow[index].errors?.active_jobcard_conflict && <Tooltip
              placement="bottomRight"
              title={ordersToShow[index].errors?.active_jobcard_conflict}
              className="edit-tooltip"
              overlayStyle={{ maxWidth: 800, whiteSpace: "normal" }}
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <div>
                <Iconmoon icon="warning-icon" size={16} color="#EA655B" />
              </div>
            </Tooltip>}
          </Col>}

          {/* PO */}
          <Col flex="100px">
            <Form.Item
              label="PO"
              labelCol={{
                style: {
                  visibility: index === 0 ? "visible" : "hidden",
                },
              }}
              name={`pono${ordersToShow[index]?.orders?.erp_order_id}`}
              initialValue={toHandlePOName(ordersToShow[index]?.po?.number)}
              className="dBlock"
              style={{ marginBottom: 0 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          {/* Order */}
          <Col flex="100px">
            <Form.Item
              label="Order"
              labelCol={{
                style: {
                  visibility: index === 0 ? "visible" : "hidden",
                },
              }}
              name={`orderNo${ordersToShow[index]?.orders?.erp_order_id}`}
              initialValue={ordersToShow[index]?.orders?.erp_order_id}
              className="dBlock"
              style={{ marginBottom: 0 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          {/* Customer */}
          <Col flex="200px">
            <Form.Item
              label="Customer"
              labelCol={{
                style: {
                  visibility: index === 0 ? "visible" : "hidden",
                },
              }}
              name={`customer${ordersToShow[index]?.orders?.erp_order_id}`}
              initialValue={ordersToShow[index]?.orders?.customer}
              rules={[{ required: true, message: "This field is required" }]}
              className="dBlock"
              style={{ marginBottom: 0 }}
            >
              <Select
                placeholder="Select Customer"
                style={{ width: "280px" }}
                suffixIcon={<DownArrowDraw />}
                showSearch
                optionFilterProp="children"
                // onChange={(e) => handleCustomer(ordersToShow[index], e)}
                // disabled={
                //   !(
                //     ordersToShow[index]?.errors?.hasOwnProperty("customer") ||
                //     ordersToShow[index]?.orders?.isCustDropdownClicked === true
                //   )
                // }
                disabled
              >
                {customerRecords?.map((cust) => (
                  <Option key={cust.code} value={cust.code}>
                    {cust.code} - {cust.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Button + Error Message */}
            {ordersToShow[index]?.errors?.customer ? (
              <div style={{ marginTop: "-9px" }}>
                <div style={{ marginTop: "-9px" }}>
                  <GlobalSet>
                    <div style={{ marginTop: "3px" }}>
                      <Button
                        key="3"
                        className="textTypeBtnERP erp-btn textBtnIcon"
                        onClick={() => {
                          addNewCustomer(ordersToShow[index]);
                        }}
                      >
                        Add Customer
                      </Button>
                    </div>
                  </GlobalSet>
                </div>
                <div
                  style={{
                    color: "#ea4e2c",
                    fontSize: "12px",
                    lineHeight: "16px",
                    whiteSpace: "normal",
                    marginTop: "-2px",
                    marginBottom: "3px",
                  }}
                >
                  {ordersToShow[index]?.errors?.customer}
                </div>
              </div>
            ) : null}
          </Col>

          {/* Order Quantity */}
          <Col flex="140px">
            <Form.Item
              label="Order Quantity"
              labelCol={{
                style: {
                  visibility: index === 0 ? "visible" : "hidden",
                },
              }}
              name={`orderQty${ordersToShow[index]?.orders?.erp_order_id}`}
              initialValue={ordersToShow[index]?.orders?.weight}
              rules={[
                { required: true, message: "This field is required" },
                {
                  validator: (_, value) => {
                    if (parseFloat(value) <= 0) {
                      return Promise.reject("Value must be greater than zero");
                    }
                    if (value && !/^\d+(\.\d{0,3})?$/.test(value)) {
                      return Promise.reject(
                        "Positive value upto 3 decimal point is accepted"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              className="dBlock"
              style={{ marginBottom: 0 }}
            >
              <Input
                placeholder="Enter Order Quantity"
                disabled={
                  !(
                    ordersToShow[index]?.errors?.hasOwnProperty("weight") ||
                    ordersToShow[index]?.orders?.isOrderQtyChanged === true
                  )
                }
                onChange={(e) => onOrderQtyChange(ordersToShow[index], e)}
              />
            </Form.Item>
            {ordersToShow[index]?.errors?.weight ? (
              <div
                style={{
                  color: "#ea4e2c",
                  fontSize: "12px",
                  lineHeight: "16px",
                  whiteSpace: "normal",
                  marginTop: "-3px",
                }}
              >
                {ordersToShow[index]?.errors?.weight}
              </div>
            ) : null}
          </Col>

          {/* Order Quantity Unit */}
          <Col flex="50px">
            <Form.Item
              label="Unit"
              labelCol={{
                style: {
                  visibility:
                    index === 0 || !rowCount.current ? "visible" : "hidden",
                },
              }}
              name={`weightUnit${ordersToShow[index]?.orders?.erp_order_id}`}
              initialValue="T"
              rules={[]}
              className="dBlock"
              style={{ marginBottom: 0 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          {/* Balance Quantity */}
          <Col flex="140px">
            <Form.Item
              label="Balance Quantity"
              labelCol={{
                style: {
                  visibility: index === 0 ? "visible" : "hidden",
                },
              }}
              name={`balanceQty${ordersToShow[index]?.orders?.erp_order_id}`}
              initialValue={ordersToShow[index]?.orders?.balance_weight}
              rules={[
                { required: true, message: "This field is required" },
                {
                  validator: (_, value) => {
                    if (parseFloat(value) <= 0) {
                      return Promise.reject("Value must be greater than zero");
                    }
                    if (value && !/^\d+(\.\d{0,3})?$/.test(value)) {
                      return Promise.reject(
                        "Positive value upto 3 decimal point is accepted"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              className="dBlock"
              style={{ marginBottom: 0 }}
            >
              <Input
                placeholder="Enter Balance Quantity"
                disabled={
                  !(
                    ordersToShow[index]?.errors?.hasOwnProperty(
                      "balance_weight"
                    ) ||
                    ordersToShow[index]?.orders?.isBalanceQtyChanged === true
                  )
                }
                onChange={(e) => onBalanceQtyChange(ordersToShow[index], e)}
              />
            </Form.Item>

            {/* Error Message Only */}
            {ordersToShow[index]?.errors?.balance_weight ? (
              <div
                style={{
                  color: "#ea4e2c",
                  fontSize: "12px",
                  lineHeight: "16px",
                  whiteSpace: "normal",
                  marginTop: "-3px",
                }}
              >
                {ordersToShow[index]?.errors?.balance_weight}
              </div>
            ) : null}
          </Col>

          {/* Balance Quantity Unit */}
          <Col flex="50px">
            <Form.Item
              label="Unit"
              labelCol={{
                style: {
                  visibility:
                    index === 0 || !rowCount.current ? "visible" : "hidden",
                },
              }}
              name={`balanceQtyUnit${ordersToShow[index]?.orders?.erp_order_id}`}
              initialValue="T"
              rules={[]}
              className="dBlock"
              style={{ marginBottom: 0 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          {/* size */}
          <Col flex="140px">
            <Form.Item
              label="Size"
              labelCol={{
                style: {
                  visibility: index === 0 ? "visible" : "hidden",
                },
              }}
              name={`size${ordersToShow[index]?.orders?.erp_order_id}`}
              initialValue={ordersToShow[index]?.orders?.width}
              rules={[
                { required: true, message: "This field is required" },
                {
                  validator: (_, value) => {
                    if (parseFloat(value) <= 0) {
                      return Promise.reject("Value must be greater than zero");
                    }
                    if (value && !/^\d+(\.\d{0,2})?$/.test(value)) {
                      return Promise.reject(
                        "Positive value upto 2 decimal point is accepted"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              className="dBlock"
              style={{ marginBottom: 0 }}
            >
              <Input
                placeholder="Enter Size"
                disabled={
                  !(
                    ordersToShow[index]?.errors?.hasOwnProperty("width") ||
                    ordersToShow[index]?.orders?.isSizeChanged === true
                  )
                }
                onChange={(e) => onSizeChange(ordersToShow[index], e)}
              />
            </Form.Item>

            {/* Error Message */}
            {ordersToShow[index]?.errors?.width ? (
              <div
                style={{
                  color: "#ea4e2c",
                  fontSize: "12px",
                  lineHeight: "16px",
                  whiteSpace: "normal",
                  marginTop: "-3px",
                }}
              >
                {ordersToShow[index]?.errors?.width}
              </div>
            ) : null}
          </Col>

          {/* size unit */}
          <Col flex="70px">
            <Form.Item
              label="Unit"
              labelCol={{
                style: {
                  visibility:
                    index === 0 || !rowCount.current ? "visible" : "hidden",
                },
              }}
              name={`sizeUnit${ordersToShow[index]?.orders?.erp_order_id}`}
              initialValue="CM"
              rules={[]}
              className="dBlock"
              style={{ marginBottom: 0 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          {/* Quality */}
          {settingsData?.settings?.orders_page?.tables?.erp_orders_review?.includes(
            "quality"
          ) && (
            <Col flex="250px">
              <Form.Item
                label="Quality"
                labelCol={{
                  style: {
                    visibility: index === 0 ? "visible" : "hidden",
                  },
                }}
                name={`quality${ordersToShow[index]?.orders?.erp_order_id}`}
                initialValue={
                  ordersToShow[index]?.orders?.product_data?.quality
                }
                rules={[{ required: true, message: "This field is required" }]}
                className="dBlock"
                style={{ marginBottom: 0 }}
              >
                <Select
                  placeholder="Select Quality"
                  style={{ width: "280px" }}
                  suffixIcon={<DownArrowDraw />}
                  showSearch
                  optionFilterProp="children"
                  disabled
                  // disabled={
                  //   !(
                  //     ordersToShow[index]?.errors?.hasOwnProperty("quality") ||
                  //     ordersToShow[index]?.orders?.isQualityChanged === true
                  //   )
                  // }
                  onChange={(e) => handleQuality(ordersToShow[index], e)}
                >
                  {gradeData
                    ?.find(
                      (ele) =>
                        ele.name ===
                        ordersToShow[index]?.orders?.product_data?.grade
                    )
                    ?.qualities?.map((item) => (
                      <Option key={item.name}>{item.name}</Option>
                    ))}
                </Select>
              </Form.Item>
              {ordersToShow[index]?.errors?.quality ? (
                <div style={{ marginTop: "-9px" }}>
                  <div style={{ marginTop: "-9px" }}>
                    <GlobalSet>
                      <div style={{ marginTop: "3px" }}>
                        <Button
                          key="3"
                          className="textTypeBtnERP erp-btn textBtnIcon"
                          onClick={() => {
                            addNewQuality(ordersToShow[index]);
                          }}
                        >
                          Add Quality
                        </Button>
                      </div>
                    </GlobalSet>
                  </div>
                  <div
                    style={{
                      color: "#ea4e2c",
                      fontSize: "12px",
                      lineHeight: "16px",
                      whiteSpace: "normal",
                      marginTop: "-2px",
                      marginBottom: "3px",
                    }}
                  >
                    {ordersToShow[index]?.errors?.quality}
                  </div>
                </div>
              ) : null}
            </Col>
          )}

          {/* GSM */}
          {settingsData?.settings?.orders_page?.tables?.erp_orders_review?.includes(
            "gsm"
          ) && (
            <Col flex="100px">
              <Form.Item
                label="GSM"
                labelCol={{
                  style: {
                    visibility: index === 0 ? "visible" : "hidden",
                  },
                }}
                name={`gsm${ordersToShow[index]?.orders?.erp_order_id}`}
                initialValue={ordersToShow[index]?.orders?.product_data?.gsm}
                className="dBlock"
                style={{ marginBottom: 0 }}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          )}

          {settingsData?.settings?.orders_page?.tables?.erp_orders_review?.includes(
            "burst_factor"
          ) && (
            <Col flex="100px">
              <Form.Item
                label="Burst Factor"
                labelCol={{
                  style: {
                    visibility: index === 0 ? "visible" : "hidden",
                  },
                }}
                name={`bf${ordersToShow[index]?.orders?.erp_order_id}`}
                initialValue={
                  ordersToShow[index]?.orders?.product_data?.burst_factor
                }
                className="dBlock"
                style={{ marginBottom: 0 }}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          )}

          {/* Product */}
          <Col flex="250px">
            <Form.Item
              label="Product"
              labelCol={{
                style: {
                  visibility: index === 0 ? "visible" : "hidden",
                },
              }}
              name={`product${ordersToShow[index]?.orders?.erp_order_id}`}
              initialValue={ordersToShow[index]?.orders?.product}
              rules={[{ required: true, message: "This field is required" }]}
              className="dBlock"
              style={{ marginBottom: 0 }}
            >
              <Select
                placeholder="Select Product"
                style={{ width: "280px" }}
                suffixIcon={<DownArrowDraw />}
                showSearch
                optionFilterProp="children"
                disabled
                // disabled={
                //   !(
                //     ordersToShow[index]?.errors?.hasOwnProperty("product") ||
                //     ordersToShow[index]?.orders?.isProductChanged === true
                //   )
                // }
                // onChange={(e) => handleProduct(ordersToShow[index], e)}
              >
                {products.map((product) => (
                  <Option key={product.code} value={product.code}>
                    {product.code} - {product.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            {ordersToShow[index]?.errors?.product ? (
              <div style={{ marginTop: "-9px" }}>
                <div style={{ marginTop: "-9px" }}>
                  <GlobalSet>
                    <div style={{ marginTop: "3px" }}>
                      <Button
                        key="3"
                        className="textTypeBtnERP erp-btn textBtnIcon"
                        onClick={() => {
                          addNewProduct(ordersToShow[index]);
                        }}
                      >
                        Add Product
                      </Button>
                    </div>
                  </GlobalSet>
                </div>
                <div
                  style={{
                    color: "#ea4e2c",
                    fontSize: "12px",
                    lineHeight: "16px",
                    whiteSpace: "normal",
                    marginTop: "-2px",
                    marginBottom: "3px",
                  }}
                >
                  {ordersToShow[index]?.errors?.product}
                </div>
              </div>
            ) : null}
          </Col>

          {/* PO date */}
          <Col flex="140px">
            <DatePickerY>
              <Form.Item
                label="PO Date"
                labelCol={{
                  style: {
                    visibility: index === 0 ? "visible" : "hidden",
                  },
                }}
                name={`poDate${ordersToShow[index]?.orders?.erp_order_id}`}
                initialValue={
                  ordersToShow[index].errors.hasOwnProperty("date") ||
                  ordersToShow[index]?.po?.date === "Invalid date" ||
                  ordersToShow[index]?.po?.date === "" ||
                  !moment(
                    ordersToShow[index]?.po?.date,
                    moment.ISO_8601,
                    true
                  ).isValid()
                    ? null
                    : moment(ordersToShow[index]?.po?.date)
                }
                rules={[{ required: true, message: "This field is required" }]}
                className="dBlock"
                style={{ marginBottom: 0 }}
              >
                <DatePicker
                  placeholder="Select date"
                  format="DD/MM/YYYY"
                  disabledDate={(current) =>
                    current &&
                    current < moment().subtract(1, "day") &&
                    !(
                      ordersToShow[index]?.errors?.hasOwnProperty("date") ||
                      ordersToShow[index]?.orders?.isDateChanged === true
                    )
                  }
                  onChange={(date) => onDateChange(ordersToShow[index], date)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </DatePickerY>
            {/* Error message if date field has validation error */}
            {ordersToShow[index]?.errors?.date ? (
              <div
                style={{
                  color: "#ea4e2c",
                  fontSize: "12px",
                  lineHeight: "16px",
                  whiteSpace: "normal",
                  marginTop: "-3px",
                }}
              >
                {ordersToShow[index]?.errors?.date}
              </div>
            ) : (
              !moment(
                ordersToShow[index]?.po?.date,
                moment.ISO_8601,
                true
              ).isValid() &&
              ordersToShow[index]?.po?.date && (
                <div
                  style={{
                    color: "#ea4e2c",
                    fontSize: "12px",
                    lineHeight: "16px",
                    whiteSpace: "normal",
                    marginTop: "-3px",
                  }}
                >
                  {ordersToShow[index]?.po?.date} is not a valid date
                </div>
              )
            )}
          </Col>
          {setRowCount()}
        </Row>
      </div>
    );

  return filteredOrders ? (
    <RightLayoutContainer>
      <PageTitleComp
        className="marginRightAdg"
        style={{ marginBottom: "12px" }}
      >
        <PageHeader
          title="ERP Order Review"
          onBack={!disabledButton?() => onCancel():false}
          extra={[
            <Button
              key="1"
              className="themeBtnForERP noBg"
              style={{ marginLeft: "1px" }}
              onClick={() => onCancel()}
              disabled={disabledButton}
            >
              Cancel
            </Button>,
            <Button key="2" className="themeBtn" disabled={disabledButton} onClick={() => saveOrders()}>
              <Iconmoon icon="addcircle" size={14} color="#ffffff" />
              Save
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      {
        !disabledButton ?
        <>
      <div
        className="showPriorityOrder"
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            marginTop: "10px",
            fontSize: "14px",
            fontFamily: "var(--sf-pro-display)",
            lineHeight: "16px",
          }}
        />
        <div
          style={{ display: "flex", flexDirection: "row", displayFlex: "end" }}
        >
          <div>
            <DisabledButtonStyle style={{ displayFlex: "end" }} />
          </div>
          <div
            style={{
              marginTop: "10px",
              marginRight: "15px",
              fontSize: "14px",
              fontFamily: "var(--sf-pro-display)",
              lineHeight: "16px",
            }}
          >
            Unresolved Orders:{" "}
            {filteredOrders?.filter((e) => e.error_count > 0).length}
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              fontFamily: "var(--sf-pro-display)",
              lineHeight: "16px",
            }}
          >
            Validated Orders:{" "}
            {filteredOrders.filter((e) => e.error_count == 0).length}
          </div>
        </div>
      </div>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
            >
              {/* <div
                style={{
                  width: "100%",
                  height: "600px", // or any height you want based on layout
                  overflowY: "auto",
                  overflowX: "hidden", // prevent horizontal scroll
                }}
              > */}
              <div
                style={{
                  overflow: "auto",
                  width: window.screen.width < 1500 ? "103.5%" : "102%",
                  height: window.screen.width > 1400 ? "600px" : "450px",
                }}
              >
                <AutoSizer>
                  {({ height, width }) => (
                    <FixedSizeList
                      key={ordersToShow?.length} 
                      height={height}
                      width={width}
                      itemCount={ordersToShow?.length}
                      itemSize={100}
                      overscanCount={5}
                      onScroll={handleScroll}
                    >
                      {RowData}
                    </FixedSizeList>
                  )}
                </AutoSizer>
                {loading && (
                  <div style={{ position: "relative" }}>
                    <div style={{ marginTop: "33%", marginLeft: "2%" }}>
                      {"Loading..."}
                    </div>
                  </div>
                )}
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      </>
      :
      <ContentMiddle>
        <div className="imageAnimate">
          <div className="imageCover">
            <LottieAnimation lotti={Loader} height={150} width={150}/>
            {/* <p>Please wait while orders get fetched from ERP.</p> */}
          </div>
        </div>
      </ContentMiddle>
}
      {customerDrawerVisible && (
        <AddNewCustomerDrawer
          visible={customerDrawerVisible}
          onClose={onCloseCustomerDrawer}
          onCustSave={onCustomerSave}
          showToaster={showToaster}
          toasterAction={setActionToaster}
          customerName={orderData?.orders?.customer_name}
          role={"customer"}
        ></AddNewCustomerDrawer>
      )}
      {productDrawerVisible && (
        <AddProductDrawer
          closeProductDrawer={closeProductDrawer}
          productDrawer={productDrawerVisible}
          setNewProductData={setNewProductData}
          selectedRecord={{
            quality: orderData?.orders?.product_data?.quality,
            grade: orderData?.orders?.product_data?.grade,
            gsm: orderData?.orders?.product_data?.gsm,
            burst_factor: orderData?.orders?.product_data?.burst_factor,
            bulk: orderData?.orders?.product_data?.bulk,
            ply: 1,
            moisture: orderData.orders?.product_data?.moisture,
            productName:`${orderData?.orders?.product_data?.quality+"-"+orderData?.orders?.product_data?.gsm+"-"+orderData?.orders?.product_data?.burst_factor+"-"+Number(orderData?.orders?.product_data?.bulk.toFixed(2))}`
          }}
        />
      )}
      {qualityDrawerVisible && (
        <AddQualityDrawer
          selectedRecord={orderData?.orders?.product_data}
          qualityDrawer={qualityDrawerVisible}
          closeQualityDrawer={closeQualityDrawer}
          onSaveQuality={onSaveQuality}
        />
      )}
      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
      {/* cancel modal */}
      <ConfirmationModal
        visible={visible}
        icon={warning}
        cancelAction={modalCancel}
        confirmAction={modalConfirm}
      >
        <span>Are you sure?</span>
        <p>{filteredOrders?.length} orders will be discarded and not saved.</p>
      </ConfirmationModal>

      {/*after saving data in api */}
      <ConfirmationModal
        visible={saveApiDataVisible}
        icon={warning}
        cancelAction={modalCancel}
        confirmAction={modalApiDataConfirm}
        isShowCancel={false}
      >
        {/* <span>Are you sure?</span> */}
        <p>Some orders couldn’t be uploaded due to technical issues. Please refetch them from the ERP.</p>
      </ConfirmationModal>
      {/* save modal */}
      <ConfirmationModal
        visible={saveModalVisible}
        icon={warning}
        cancelAction={cancelSaveModal}
        confirmAction={confirmSaveModal}
      >
        <span>Are you sure?</span>
        {filteredOrders?.filter((ele) => ele.error_count === 0 && Object.keys(ele.errors || {}))?.length > 0 &&
          <p>{filteredOrders?.filter((ele) => ele.error_count === 0 && Object.keys(ele.errors || {}))?.length} 
          {""} orders will be saved successfully.</p>}
        {filteredOrders?.filter((ele) => ele.error_count > 0 && Object.keys(ele.errors))?.length > 0 &&
        <p style={{marginTop: (filteredOrders?.filter((ele) => ele.error_count === 0 && Object.keys(ele.errors || {}))?.length > 0) ? "-30px" : "1px"}}>
          {filteredOrders?.filter((ele) => ele.error_count > 0 && Object.keys(ele.errors))?.length} 
          {""} orders will not be saved and will be discarded.</p>}
      </ConfirmationModal>
    </RightLayoutContainer>
  ) : null;
};
export default ReviewConflictingOrders;